import Text from '@components/Text';
import colors from '@constants/colors';
import { useRef } from 'react';

import useAnimation from './hooks/useAnimation';
import styles from './styles.module.scss';

function PreventCapture() {
  const ref = useRef<HTMLDivElement>(null);
  useAnimation(ref);
  return (
        <div className={styles.wrapper}>
            <div className={styles.container}
                 ref={ref}>
                {Array.from({ length: 10 }).map((_, i) => (
                    <div className={styles.item}
                         key={i.toString()} >
                        <Text color={colors.gray7}
                              fontWeight='medium'
                              className={styles.itemText}>
                            캡쳐/출력된 쿠폰 이미지는 사용불가
                        </Text>
                    </div>
                ))}
            </div>
        </div>
  );
}

export default PreventCapture;
